const colorPresets = [
  { gradient: 'from-blue-500 via-blue-600 to-indigo-700', name: 'Ocean', glow: 'shadow-blue-500/50' },
  { gradient: 'from-purple-500 via-purple-600 to-pink-600', name: 'Galaxy', glow: 'shadow-purple-500/50' },
  { gradient: 'from-emerald-500 via-green-600 to-teal-700', name: 'Forest', glow: 'shadow-emerald-500/50' },
  { gradient: 'from-cyan-400 via-cyan-500 to-blue-600', name: 'Arctic', glow: 'shadow-cyan-400/50' },
  { gradient: 'from-pink-500 via-rose-500 to-red-600', name: 'Sunset', glow: 'shadow-pink-500/50' },
  { gradient: 'from-orange-500 via-amber-500 to-yellow-600', name: 'Flame', glow: 'shadow-orange-500/50' },
  { gradient: 'from-indigo-500 via-indigo-600 to-purple-700', name: 'Nebula', glow: 'shadow-indigo-500/50' },
  { gradient: 'from-teal-500 via-teal-600 to-cyan-700', name: 'Lagoon', glow: 'shadow-teal-500/50' },
  { gradient: 'from-rose-500 via-pink-600 to-purple-700', name: 'Bloom', glow: 'shadow-rose-500/50' },
  { gradient: 'from-amber-500 via-yellow-500 to-orange-600', name: 'Gold', glow: 'shadow-amber-500/50' }
];

export default colorPresets;